var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar",class:{ active: _vm.active }},[_c('div',{staticClass:"menu"},_vm._l((_vm.menuItems),function(item){return _c('div',{key:item.name,class:['menu-item', { active: _vm.isActive(item) }],on:{"click":function($event){return _vm.navigateTo(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }